<template>
  <funding-project-base :state="state">
    <progress-report
      :can-edit="false"
      :is-monitor="true"
      :is-msp="true"
      :monitoring="state.monitoring"
    />

    <!-- Forecast Summary Chart -->
    <forecast-summary-chart
      :forecast="forecast"
      :for-version="currentForecastToShow"
      :intervention-rate="state.competition.max_partner_grant_intervention_rate || 100"
    />

    <!-- Forecast Matrix -->
    <forecast-matrix
      :can-edit="false"
      :forecast="forecast"
      :for-version="currentForecastToShow"
      :project-id="state.project.uuid"
      :project-partner-id="projectPartner.competition_project_partner_id"
      :intervention-rate="state.competition.max_partner_grant_intervention_rate || 100"
    />
  </funding-project-base>
</template>
<script>
export default {
  name: "FundingProjectsView",
  computed: {
    forecast() {
      return this.state.forecast;
    },
    projectPartner() {
      return this.state.partners?.[0] || {};
    },
    currentForecastToShow() {
      const hasInitials = this.forecast.initials_completed ?? false;
      const currentRevision = this.forecast.current?.revision || 0;
      const hasSubmittedCurrent = this.forecast.current?.submitted ?? false;

      if (!hasInitials) {
        return 0;
      }

      if (hasInitials && !hasSubmittedCurrent) {
        return currentRevision - 1;
      }

      return currentRevision;
    },
  },
};
</script>
